var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6H11.5C12.7426 6 13.75 7.00736 13.75 8.25V15.75C13.75 16.9926 12.7426 18 11.5 18H2.5C1.25736 18 0.25 16.9926 0.25 15.75V8.25C0.25 7.00736 1.25736 6 2.5 6ZM2.5 7.5C2.08579 7.5 1.75 7.83579 1.75 8.25V15.75C1.75 16.1642 2.08579 16.5 2.5 16.5H11.5C11.9142 16.5 12.25 16.1642 12.25 15.75V8.25C12.25 7.83579 11.9142 7.5 11.5 7.5H2.5Z",
    fill: "#6D777B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.5V5.925C11.5 6.79485 10.7948 7.5 9.925 7.5H4.075C3.20515 7.5 2.5 6.79485 2.5 5.925V4.5C2.5 2.01472 4.51472 0 7 0C9.48528 0 11.5 2.01472 11.5 4.5ZM7 1.5C5.34315 1.5 4 2.84315 4 4.5V5.925C4 5.96642 4.03358 6 4.075 6H9.925C9.96642 6 10 5.96642 10 5.925V4.5C10 2.84315 8.65685 1.5 7 1.5Z",
    fill: "#6D777B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5C8.5 11.3284 7.82843 12 7 12C6.17157 12 5.5 11.3284 5.5 10.5C5.5 9.67157 6.17157 9 7 9C7.82843 9 8.5 9.67157 8.5 10.5Z",
    fill: "#6D777B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.6243C6.25 11.2101 6.58579 10.8743 7 10.8743C7.41421 10.8743 7.75 11.2101 7.75 11.6243V14.2286C7.75 14.6428 7.41421 14.9786 7 14.9786C6.58579 14.9786 6.25 14.6428 6.25 14.2286V11.6243Z",
    fill: "#6D777B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock-2.37b896ea649745458771ff881c709f86.svg";
export { ForwardRef as ReactComponent };